import { crossfade as svelteCrossfade } from 'svelte/transition';
import { quintOut} from 'svelte/easing';
import { flip } from 'svelte/animate';
import { state } from './stores.js';
import { get } from 'svelte/store';
import { phoneLayout } from './mobile/layout.js';


let [origSend, origReceive] = svelteCrossfade({
    duration: d => Math.sqrt(d * 200),

    fallback(node, params) {
        //if(get(state).cardsByID[params.key]) console.log('falling back on '+get(state).cardsByID[params.key].name)
        const style = getComputedStyle(node);
        const transform = style.transform === 'none' ? '' : style.transform;
        return {
            duration: 200,
            easing: quintOut,
            css: t => `
                transform: ${transform};
                opacity: ${t}
            `
        };
    }
});

let timeouts = new Map();

let send = (node, params) => {
    //let origFunc = origSend(node, params)
    if(isNaN(params.key)) return {};
    if(get(phoneLayout)) return { duration: 0 }; // the desktop cards are leaving for the phone layout: go now
    if(node.style.animation){
        //console.log('send animating');
        return {};
    }
    let match = timeouts.get(params.key);
    if(match){
        //console.log(`send: match found for ${get(state).cardsByID[params.key].name}: clearing`)
        clearTimeout(match); // Already received
        timeouts.delete(params.key)
    }else{
        //console.log(`send: setting up match for ${get(state).cardsByID[params.key].name}`);
        let match = setTimeout(() => {
            //console.log(params.key)
            if(node && node.style.animation){
                //console.log(`send still animating! ${params.key}`, node.style.animation)
                //node.style.animation = null;
                
            }
            //console.log(`send: clearing match ${get(state).cardsByID[params.key].name}`)
            timeouts.delete(params.key)
        }, 300);
        timeouts.set(params.key, match);
    }
    
    return origSend(node, params);
    return () => {
        if(node && node.style.animation){
            console.log('animating already!')
            node.style.animation = null;
            timeouts.delete(node)
        }
        origSend(node, params);
    }
        //origSend(node, params);
}

let receive = (node, params) => {
    //let origFunc = origReceive(node, params);
    if(isNaN(params.key)) return {};
    if(get(phoneLayout)) return { duration: 0 };
    if(node.style.animation){
        //console.log('receive animating');
        node.style.animation = null;
    }
    let match = timeouts.get(params.key);
    if(match){
        //console.log(`receive: match found for ${get(state).cardsByID[params.key].name}: clearing`)
        clearTimeout(match); // Already received
        timeouts.delete(params.key)
    }else{
        //console.log(`receive: setting up match for ${get(state).cardsByID[params.key].name}`);
        let match = setTimeout(() => {
            if(node && node.style.animation){
               //console.log(`rec still animating! ${params.key}`, node.style.animation)
                node.style.animation = null;
            }
            //console.log(`receive: clearing match for ${get(state).cardsByID[params.key].name}`)
            timeouts.delete(params.key)
        }, 300);
        timeouts.set(params.key, match);
    }

    return origReceive(node, params)
    return () => {
        if(node && node.style.animation){
            console.log('animating already!')
            return;
        }
        origReceive(node, params)();
    }
}

export const crossfade = [send, receive];

export function customFlip(node, fromTo) {
	if (node.style.animation){
        //console.log('cancelling previous animation')
        node.style.animation = null;
    }
	return flip(node, fromTo, { duration: 200 });
}
